import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { IconButton } from './IconButton';

const IconLinkComponent = ({ href }) => (
  <IconButton className="ml5" href={href} icon="reply" size="sm" title="Open link in a new tab" />
);

IconLinkComponent.propTypes = {
  href: PropTypes.string.isRequired,
};

/** Icon link component. */
export const IconLink = memo(IconLinkComponent);
